import React, { useState, useEffect } from "react"
import {
	Box,
	Tooltip,
	OutlinedInput,
	InputLabel,
	MenuItem,
	FormControl,
	ListItemText,
	Select,
	Checkbox,
	makeStyles,
	TextField,
	useTheme,
} from "@material-ui/core"
import { useSelector } from "react-redux"
import { KeyboardArrowDown } from "@material-ui/icons"

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 120,
		minWidth: 120,
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	font: {
		fontWeight: 400,
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
}))

//basic settings
const MenuProps = {
	PaperProps: {
		style: {
			width: 150,
			maxHeight: 287,
			textTransform: "capitalize",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	variant: "menu",
	getContentAnchorEl: null,
}

const Tags = ({ handleTagChange, selected = [], setSelected = () => {}, disableFilters }) => {
	const classes = useStyles()
	const theme = useTheme()

	const tags = useSelector((state) => state.tags?.custom_tags?.tags || [])

	const isAllSelected = tags.length > 0 && selected.length === tags.length

	const handleChange = (event) => {
		const value = event.target.value

		if (value[value?.length - 1] === "all") {
			//const values = selected?.length === tags?.length ? [] : tags?.map((tag) => tag?.name)
			//setSelected(values)
			//handleTagChange(values)
			const ids = selected?.length === tags?.length ? [] : tags?.map((tag) => tag?.id)
			handleTagChange(ids)
			setSelected(ids)
			return
		}
		setSelected(value)
		handleTagChange(value)
		//const ids = tags.filter((tag) => value.includes(tag?.name)).map((tag) => tag?.id)
		//handleTagChange(ids)
	}

	const getTagNames = (tagIds) => {
		let tagNames = []
		if (tagIds?.length > 0) {
			for (let i = 0; i < tagIds?.length; i++) {
				if (tags?.length > 0) {
					const found = tags?.filter((tag) => tag?.id === tagIds[i])
					found?.[0]?.name && tagNames?.push(found?.[0]?.name)
				}
			}
		}
		return tagNames
	}

	const getTagName = (tagId) => {
		const tag = tags?.find((item) => item.id === tagId)
		return tag?.name || null
	}

	return (
		<Box className={classes.boxWrapper} m={1}>
			<FormControl fullWidth size="small">
				{/* <InputLabel id="tag-select-label" className={classes.font}>
					Tags
				</InputLabel> */}
				<Tooltip placement="top" arrow title={getTagNames(selected)?.join(", ")}>
					{/* <Select
						labelId="tag-multiple-checkbox-label"
						id="tag-multiple-checkbox"
						multipleKeyboardArrowDown
						value={selected}
						onChange={handleChange}
						input={<OutlinedInput label="Tags" />}
						renderValue={(selected) => selected.join(", ")}
						MenuProps={MenuProps}
						IconComponent={KeyboardArrowDown}
						inputProps={{ style: { fontWeight: 400 } }}
					> */}
					<TextField
						//style={{ width: "100%" }}
						//style={{ color: "#2C3533", fontWeight: "700" }}
						variant="outlined"
						value={selected}
						onChange={handleChange}
						select
						label="Tags"
						id="tag-multiple-checkbox-label"
						SelectProps={{
							labelId: "tag-multiple-checkbox-label",
							MenuProps: MenuProps,
							IconComponent: KeyboardArrowDown,
							renderValue: (selected) => {
								let selectedTags = getTagNames(selected)
								return selectedTags?.join(", ")
							},
							multiple: true,
							// value: selected,
							// onChange: handleChange,
							onOpen: () => {
								setTimeout(() => {
									selected?.length > 0 &&
										!isAllSelected &&
										document.querySelector(`[data-name=${getTagName(selected?.[0])}]`)?.scrollIntoView()
								}, 1)
							},
						}}
						InputLabelProps={{ style: { fontWeight: 400 } }}
						size="small"
						className={classes.select}
						disabled={disableFilters}
					>
						{/*Loading heandle here*/}
						<MenuItem style={{ maxWidth: 150, paddingLeft: 1 }} key={"all"} value={"all"}>
							<Checkbox size="small" checked={isAllSelected} />
							<ListItemText primary={"All"} primaryTypographyProps={{ style: { fontWeight: 400 } }} />
						</MenuItem>
						{tags?.map((tag) => (
							<MenuItem style={{ maxWidth: 150, paddingLeft: 1 }} key={tag?.id} value={tag?.id} data-name={tag?.name}>
								<Checkbox size="small" checked={selected?.indexOf(tag?.id) > -1} />
								<Tooltip placement="top" arrow title={tag?.name}>
									<ListItemText
										// style={{
										// 	textTransform: "capitalize",
										// 	overflow: "hidden",
										// 	textOverflow: "ellipsis",
										// 	//display: "-webkit-box",
										// 	WebkitLineClamp: "1",
										// 	WebkitBoxOrient: "vertical",
										// }}
										primary={tag?.name}
										style={{ fontWeight: 400 }}
										primaryTypographyProps={{ style: { fontWeight: 400 } }}
									/>
								</Tooltip>
							</MenuItem>
						))}
					</TextField>
				</Tooltip>
			</FormControl>
		</Box>
	)
}

export default Tags
